module.exports = __webpack_public_path__ + "img/Boy_020009.03ddc3e5.png";